import useProjectEntriesCall, { toTimestampLike } from './useProjectEntriesCall'

/**
 * @typedef {object} TaskEntry
 * @property {string} docid - Document-id van de taak
 * @property {{toDate: () => Date} | null} Timestamp - Zelfde vorm als een Firestore-Timestamp
 * @property {string} Type - Soort taak (altijd 'addressVisit')
 */

/** @returns {TaskEntry} */
const toTaskDoc = (/** @type {{id: string, t: number|null, type?: string}} */ entry) => ({
    docid: entry.id,
    Timestamp: toTimestampLike(entry.t),
    Type: entry.type || '',
})

/**
 * De huisbezoektaken van één project, voor de kaart 'Taken' op de
 * projectdetailpagina, via de Cloud Function `getProjectTaskEntries`. De
 * functie geeft alleen id, tijdstip en soort terug. Las tot 2026-11-03
 * rechtstreeks uit Tasks, wat alleen werkte dankzij een te ruime regel.
 *
 * @param {string} compagnyId - Het project; '' = nog onbekend of niet nodig
 * @returns {{docs: Array<TaskEntry> | '', error: {code?: string, message?: string} | null, loading: boolean}}
 */
const useProjectTaskEntries = (compagnyId) => useProjectEntriesCall(
    'getProjectTaskEntries', compagnyId, toTaskDoc, 'useProjectTaskEntries'
)

export default useProjectTaskEntries
